/** Shared pricing used by inquiry confirmation + booking API */
export const SERVICE_PRICES: Record<string, number> = {
  Photographer: 800,
  Videographer: 900,
  Bartender: 350,
  Caterer: 1200,
  'Limo / Transport': 600,
  Security: 400,
  'Photo Booth': 500,
  Florist: 450,
  'Baker / Cake': 300,
  Decorator: 550,
  'Hair & Makeup': 400,
  'Live Musician': 750,
};

export const BASE_DJ_PRICE = 800;
export const COORDINATION_FEE_RATE = 0.2;
export const DEPOSIT_RATE = 0.25;
export const BALANCE_DAYS_BEFORE = 14;

export function calculateBookingQuote(services: string[]) {
  const addOnSubtotal = services.reduce((sum, s) => sum + (SERVICE_PRICES[s] || 0), 0);
  const coordinationFee = Math.round(addOnSubtotal * COORDINATION_FEE_RATE);
  const totalCost = BASE_DJ_PRICE + addOnSubtotal + coordinationFee;
  const depositAmount = Math.round(totalCost * DEPOSIT_RATE);
  const balanceDue = totalCost - depositAmount;
  return { addOnSubtotal, coordinationFee, totalCost, depositAmount, balanceDue };
}

export function getBalanceDueDateISO(eventDate: string): string {
  if (!eventDate) return new Date().toISOString().split('T')[0];
  const [year, month, day] = eventDate.split('-').map(Number);
  const due = new Date(year, month - 1, day);
  due.setDate(due.getDate() - BALANCE_DAYS_BEFORE);
  return due.toISOString().split('T')[0];
}

export function buildContractTermsText(params: {
  clientName: string;
  eventType: string;
  eventDate: string;
  venue: string;
  totalCost: number;
  depositAmount: number;
  balanceDue: number;
  balanceDueDate: string;
  services: string[];
}): string {
  return [
    `DJ ExXtra / Maximum Effort Entertainment — Event Services Agreement`,
    ``,
    `Client: ${params.clientName}`,
    `Event: ${params.eventType}`,
    `Date: ${params.eventDate || 'TBD'}`,
    `Venue: ${params.venue || 'TBD'}`,
    `Add-ons: ${params.services.length ? params.services.join(', ') : 'None'}`,
    ``,
    `Total Estimated Cost: $${params.totalCost.toLocaleString()}`,
    `Deposit (25%): $${params.depositAmount.toLocaleString()} — due to secure the date`,
    `Balance: $${params.balanceDue.toLocaleString()} — due by ${params.balanceDueDate}`,
    ``,
    `Terms:`,
    `1. Deposit is required to reserve the event date.`,
    `2. Remaining balance is due 14 days before the event.`,
    `3. Deposit is non-refundable within 30 days of the event.`,
    `4. A 20% coordination fee applies to vendor add-on rates.`,
    `5. Overtime is billed at $150/hr beyond contracted hours.`,
    `6. Events beyond 50 miles may incur a travel fee.`,
    ``,
    `A formal signed contract will be finalized with Christopher after confirmation.`,
  ].join('\n');
}
